import { enableProdMode, LOCALE_ID, isDevMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { DatePipe } from '@angular/common';
import { VersionUpdateService } from './app/shared/services/version-update.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { SharedModule } from './app/shared/shared.module';
import { TranslocoRootModule } from './app/transloco/transloco-root.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app/app.component';
import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './app/core/services/app-title.strategy';
import {
  AllCommunityModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  CustomFilterModule,
  EventApiModule,
  LocaleModule,
  ModuleRegistry,
  NumberFilterModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowSelectionModule,
  TextFilterModule,
  TooltipModule,
  ValidationModule
} from 'ag-grid-community';
import { registerLocaleData } from '@angular/common';
import localeDeCh from '@angular/common/locales/de-CH';
import { DateAdapter, provideCalendar } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { ApiInterceptor } from 'app/core/interceptors/api.interceptor';
import { DateInterceptor } from 'app/core/interceptors/date.intercepor';
import { CoreModule } from 'app/core/core.module';
import { MODAL_CONFIG_DEFAULT_OVERRIDE, ModalModule, ModalOptions } from 'ngx-bootstrap/modal';
import { authInterceptor } from 'app/core/auth';

const defaultModules = [BrowserModule];
const internalModules = [AppRoutingModule, SharedModule, CoreModule];
const externalModules = [TranslocoRootModule];

if (environment.production) {
  enableProdMode();
}

// Register minimum AG Grid modules
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  RenderApiModule,
  EventApiModule,
  RowSelectionModule,
  RowApiModule,
  TextFilterModule,
  NumberFilterModule,
  CustomFilterModule,
  ColumnAutoSizeModule,
  RowAutoHeightModule,
  TooltipModule,
  CellStyleModule,
  LocaleModule,
  AllCommunityModule
]);
if (!environment.production) {
  ModuleRegistry.registerModules([ValidationModule]);
}

registerLocaleData(localeDeCh);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateInterceptor,
      multi: true
    },
     importProvidersFrom(ModalModule.forRoot()),
    {
      provide: MODAL_CONFIG_DEFAULT_OVERRIDE,
      useValue: {
        ignoreBackdropClick: true,
        keyboard: false

      } satisfies ModalOptions
    },
    importProvidersFrom(
      defaultModules,
      internalModules,
      externalModules,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
      })
      // REMOVED: OAuthModule.forRoot() - migrated to BFF pattern
    ),
    DatePipe,
    VersionUpdateService,
    // BFF Auth: Add functional interceptor for cookie-based auth
    provideHttpClient(
      withInterceptorsFromDi(), // Keep existing interceptors
      withInterceptors([authInterceptor]) // Add BFF auth interceptor
    ),
    { provide: LOCALE_ID, useValue: 'de-CH' },
    // Scope cannot be null if defined => otherwise the translation will not work
    { provide: TRANSLOCO_SCOPE, useValue: ['pmtBootstrap', 'pmtDatepicker', 'agGrid'] },
    provideCalendar({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    provideAnimations()
  ]
}).catch((err: unknown) => {
  console.error(err);
});
